export function ManagerNotificationSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/manager-notification.svg'"></ng-include>`
    }
}